import NavbarCollapse from './navbar-collapse';
import gsap from 'gsap';
import Headroom from 'headroom.js';

window.submenuActive = false;

export function init() {
  const navbar = document.querySelector('[data-navbar]');

  if (!navbar) return;

  const navbarToggle = navbar.querySelector('[data-navbar-toggle]');
  const navbarCollapse = navbar.querySelector('[data-navbar-collapse]');
  const navbarMenuItems = navbarCollapse.querySelectorAll('[data-navbar-menu] .nav-item');

  // headroom js
  const headroom = new Headroom(navbar, { offset: 150 });
  headroom.init();

  // navbar
  new NavbarCollapse({
    trigger: navbarToggle,
    node: navbarCollapse,
    onReverseStart: () => {
      navbar.classList.remove('is-open');
      document.body.classList.add('navbar-opening');
    },
    timeline: (instance) => {
      const { node } = instance.options;

      const tl = gsap.timeline({
        paused: true,
        onStart: () => {
          document.body.classList.add('navbar-open');
          document.body.classList.add('navbar-opening');
          navbar.classList.add('is-open');
        },
        onComplete: () => {
          document.body.classList.remove('navbar-opening');
        },
        onReverseComplete: () => {
          document.body.classList.remove('navbar-open');
          document.body.classList.remove('navbar-opening');
        },
      });

      // navbar nav
      tl.fromTo(
        node,
        {
          translateX: '100%',
        },
        {
          translateX: '0',
          duration: 0.5,
        }
      );

      // navbar items
      tl.fromTo(
        [navbarMenuItems],
        {
          translateX: '-100px',
          opacity: 0,
        },
        {
          translateX: '0',
          opacity: 1,
          duration: 0.2,
          stagger: 0.05,
        }
      );

      return tl;
    },
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/NavbarCollapse/index.js